var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "#7869CC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.465 22.2115L19.3019 1.88462C18.5944 0.706731 17.3477 0 16 0C14.6523 0 13.4056 0.706731 12.6981 1.85096L0.534952 22.2115C-0.172599 23.3894 -0.172599 24.8365 0.501259 26.0481C1.17512 27.2596 2.42176 28 3.83686 28H28.1631C29.5446 28 30.7912 27.2596 31.4987 26.0481C32.1726 24.8365 32.1726 23.3894 31.465 22.2115ZM29.1739 24.7356C29.0729 24.9038 28.7696 25.3077 28.1631 25.3077H3.83686C3.23039 25.3077 2.92715 24.9038 2.82607 24.7356C2.72499 24.5673 2.52283 24.0962 2.82607 23.5913L15.0229 3.23077C15.3261 2.72596 15.7978 2.65865 16 2.65865C16.2022 2.65865 16.6739 2.72596 16.9771 3.23077L29.1402 23.5913C29.4435 24.0962 29.275 24.5673 29.1739 24.7356Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 17.7692C16.8082 17.7692 17.4484 17.0962 17.4484 16.3221V10.1971C17.4484 9.38942 16.7745 8.75 15.9996 8.75C15.1909 8.75 14.5508 9.42308 14.5508 10.1971V16.2885C14.5508 17.0962 15.1909 17.7692 15.9996 17.7692Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 22.6493C16.9868 22.6493 17.7863 21.8508 17.7863 20.8657C17.7863 19.8806 16.9868 19.082 16.0006 19.082C15.0143 19.082 14.2148 19.8806 14.2148 20.8657C14.2148 21.8508 15.0143 22.6493 16.0006 22.6493Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.0cba1ea1234824c8d0be7b027d015b9b.svg";
export { ForwardRef as ReactComponent };